import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Dialog, Classes
} from '@blueprintjs/core';
import './errors-dialog.scss';

type Props = {
  data: { xtp: string, xtpOptions: string },
  wasXtpUpdatedWithErrors: boolean,
}

const ErrorsDialog = ({ data, wasXtpUpdatedWithErrors }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setOpen(wasXtpUpdatedWithErrors);
  }, [wasXtpUpdatedWithErrors]);

  const handleCLose = () => {
    setOpen(false);
  }

  const renderErrorSection = (title: string, error: string) => {
    if (!error) {
      return null;
    }

    return (
      <div className="errors-dialog-section">
        <h5 className="errors-dialog-section-title">{title}:</h5>
        <ul className="errors-dialog-errors">
          <li key={error} className="errors-dialog-errors-item">{error}</li>
        </ul>
      </div>
    );
  }

  return (
    <Dialog isOpen={isOpen} title={t('xtp.form.dialog.title')} onClose={handleCLose} className="errors-dialog">
      <div className="errors-dialog-body">
        <p className="errors-dialog-note">{t('xtp.form.dialog.note')}</p>
        <div className="errors-dialog-sections">
          {renderErrorSection(t('xtp.form.dialog.xtp'), data.xtp)}
          {renderErrorSection(t('xtp.form.dialog.xtpOptions'), data.xtpOptions)}
        </div>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={handleCLose} intent="primary" text={t('common.button.ok')} />
        </div>
      </div>
    </Dialog>
  )
}

export default ErrorsDialog;
